import React from 'react'

function BtnRightArrow(props) {

    return (
        <>
            <span className={`username-container ${props.className} BtnRightArrow hover-effect-blue`} onClick={props.onClick}>
                <i class="fa-solid fa-arrow-right"></i>
            </span>
        </>
    )
}

export default BtnRightArrow;